/** Shared Playwright data-testid values for E2E and SPA (import via `e2e/playwrightTestIds`). */

export const TEST_ID_PROPOSAL_TEMPLATE_BESPOKE_BUTTON = 'bespoke-template-button'
export const TEST_ID_PROPOSAL_TEMPLATE_BESPOKE_V2_BUTTON = 'bespoke-v2-template-button'
export const TEST_ID_CUSTOMIZE_PROPOSAL_BUTTON = 'customize-proposal-button'
export const TEST_ID_PROPOSAL_TEMPLATE_FIELD = 'proposal-template-field'
export const TEST_ID_PROPOSAL_NAV_LINK = 'proposal-nav-link'
export const TEST_ID_CLASSIC_TEMPLATE_CARD = 'classic-template-card'
export const TEST_ID_BESPOKE_IFRAME = 'bespoke-proposal-iframe'
export const TEST_ID_BESPOKE_ANNUAL_USAGE = 'bespoke-annual-usage'
export const TEST_ID_BESPOKE_FILE_INPUT = 'bespoke-file-input'
export const TEST_ID_BESPOKE_FILE_INPUT_DROPZONE = 'bespoke-file-input-dropzone'
export const TEST_ID_LEARN_HOW_TO_CUSTOMIZE_VIEWS_BUTTON = 'learn-how-to-customize-views-button'
export const TEST_ID_CUSTOMER_VIEWS_BUTTON = 'customer-views-button'
export const TEST_ID_CLOSE_CUSTOMER_VIEWS_BUTTON = 'close-customer-views-button'

export const TEST_ID_CASHFLOW_NAV_LINK = 'cashflow-nav-link'
export const TEST_ID_CASHFLOW_MOBILE_NAV_LINK = 'cashflow-mobile-nav-link'
export const TEST_ID_CASHFLOW_REGISTRATION_DIALOG = 'cashflow-registration-dialog'
export const TEST_ID_CASHFLOW_REGISTRATION_BANK_TRANSFER_TAB = 'cashflow-registration-bank-transfer-tab'
export const TEST_ID_CASHFLOW_REGISTRATION_CUSTOMIZED_TAB = 'cashflow-registration-customized-tab'
export const TEST_ID_CASHFLOW_REGISTRATION_ACTIVATE_BTN = 'cashflow-registration-activate-btn'
export const TEST_ID_CASHFLOW_REGISTRATION_SUCCESS_DIALOG = 'cashflow-registration-success-dialog'
export const TEST_ID_CASHFLOW_REGISTRATION_SUCCESS_CONTINUE_BTN = 'cashflow-registration-success-continue-btn'
export const TEST_ID_CASHFLOW_SETUP_CARD = 'cashflow-setup-card'
export const TEST_ID_CASHFLOW_SETTINGS_BTN = 'cashflow-settings-btn'
export const TEST_ID_CASHFLOW_SETTINGS_MENU = 'cashflow-settings-menu'

/** CashFlow hub floating menu (configure / transfer instructions E2E). */
export const TEST_ID_CASHFLOW_TRANSFER_INSTRUCTIONS_LINK = 'cashflow-transfer-instructions-link'
